import { render, staticRenderFns } from "./ProtectionJuridique.vue?vue&type=template&id=b10b3bd6&"
import script from "./ProtectionJuridique.vue?vue&type=script&lang=js&"
export * from "./ProtectionJuridique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports